<!-- Authorized users -->
<div *ngIf="allowed">
    <section class="page-title-area">
        <div class="container">
            <div class="page-title-content">
                <h2>Insights Dashboard</h2>
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li>Insights Dashboard</li>
                </ul>
            </div>
        </div>
        <div class="shape-img1">
            <img src="assets/img/shape/shape1.svg" alt="image" />
        </div>
        <div class="shape-img2">
            <img src="assets/img/shape/shape2.png" alt="image" />
        </div>
        <div class="shape-img3">
            <img src="assets/img/shape/shape3.png" alt="image" />
        </div>
    </section>

    <!-- Main Content -->
    <section class="faq-area ptb-100">
        <div class="container">
            <!-- Loading container -->
            <div *ngIf="loading$ | async" class="loading">
                Loading...
            </div>

            <!-- Error container -->
            <div *ngIf="error$ | async as error" class="error">
                {{error}}
            </div>

            <!-- Keyword list -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <h4 class="mb-10 font-weight-bold text-dark">
                    TOP 5 Search Keywords
                </h4>
                <table *ngIf="(keywords$ | async) as keywords">
                    <thead>
                        <tr>
                            <th>Keyword</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let keyword of keywords">
                            <td>{{ keyword.keyword }}</td>
                            <td>{{ keyword.quantity }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</div>

<!-- Users not authorized -->
<div *ngIf="!allowed">
    <section class="page-title-area">
        <div class="container" style="font-weight: bold;">
            Access Forbidden! 🚫
        </div>
    </section>
</div>
